var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{attrs:{"fields":_vm.fields,"items":_vm.dialerData.Contacts},scopedSlots:_vm._u([{key:"headerText",fn:function(){return [_vm._v(" Список контактов для обзвона в задании \""+_vm._s(_vm.dialerData.Caption)+"\" ")]},proxy:true},{key:"cell(ContactName)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.ContactName)+" ")]}},{key:"cell(LastOperationDateTime)",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.LastOperationDateTime.replace(/T/g, ' '))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }